"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CardScan API
 * The official documentation for the CardScan API Clients.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardScanApi = exports.CardScanApiFactory = exports.CardScanApiFp = exports.CardScanApiAxiosParamCreator = void 0;
const configuration_1 = require("../configuration");
const yup = __importStar(require("yup"));
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const fast_xml_parser_1 = require("fast-xml-parser");
const form_data_1 = __importDefault(require("form-data"));
const axios_1 = __importDefault(require("axios"));
const models_1 = require("../models");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_2 = require("../models");
/**
 * CardScanApi - axios parameter creator
 * @export
 */
const CardScanApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Card - Send performance data
         * @param {string} cardId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardPerformance: (cardId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cardId' is not null or undefined
            (0, common_1.assertParamExists)('cardPerformance', 'cardId', cardId);
            const localVarPath = `/cards/{card_id}/performance`
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new card
         * @param {CreateCardRequest} [createCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard: (createCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCardRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Eligibility Record
         * @param {CreateEligibilityRequest} [createEligibilityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEligibility: (createEligibilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createEligibilityRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Card
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardById: (cardId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cardId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCardById', 'cardId', cardId);
            const localVarPath = `/cards/{card_id}`
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Direct Upload
         * @param {ScanOrientation} orientation
         * @param {ScanCaptureType} captureType
         * @param {string} cardId
         * @param {string | any} [stringAny]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directUpload: (orientation, captureType, cardId, stringAny, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orientation' is not null or undefined
            (0, common_1.assertParamExists)('directUpload', 'orientation', orientation);
            // verify required parameter 'captureType' is not null or undefined
            (0, common_1.assertParamExists)('directUpload', 'captureType', captureType);
            // verify required parameter 'cardId' is not null or undefined
            (0, common_1.assertParamExists)('directUpload', 'cardId', cardId);
            const localVarPath = `/cards/{card_id}/upload`
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (orientation !== undefined) {
                localVarQueryParameter['orientation'] = orientation;
            }
            if (captureType !== undefined) {
                localVarQueryParameter['capture_type'] = captureType;
            }
            localVarHeaderParameter['Content-Type'] = 'image/jpeg';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stringAny, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Card - Generate Upload URL
         * @param {string} cardId
         * @param {number} [expiration]
         * @param {GenerateCardUploadUrlRequest} [generateCardUploadUrlRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardUploadUrl: (cardId, expiration, generateCardUploadUrlRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cardId' is not null or undefined
            (0, common_1.assertParamExists)('generateCardUploadUrl', 'cardId', cardId);
            const localVarPath = `/cards/{card_id}/generate-upload-url`
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generateCardUploadUrlRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate Magic Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMagicLink: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/generate-magic-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate an upload URL
         * @param {number} expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUploadUrl: (expiration, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'expiration' is not null or undefined
            (0, common_1.assertParamExists)('generateUploadUrl', 'expiration', expiration);
            const localVarPath = `/generate-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Access Token
         * @param {string} [userId] The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Card by ID
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardById: (cardId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cardId' is not null or undefined
            (0, common_1.assertParamExists)('getCardById', 'cardId', cardId);
            const localVarPath = `/cards/{card_id}`
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Eligibility
         * @param {string} eligibilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityById: (eligibilityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eligibilityId' is not null or undefined
            (0, common_1.assertParamExists)('getEligibilityById', 'eligibilityId', eligibilityId);
            const localVarPath = `/eligibility/{eligibility_id}`
                .replace(`{${"eligibility_id"}}`, encodeURIComponent(String(eligibilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Cards
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCards: (limit, cursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Eligibility
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEligibility: (limit, cursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Cards (200) OK
         * @param {string} query
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCards: (query, limit, cursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            (0, common_1.assertParamExists)('searchCards', 'query', query);
            const localVarPath = `/cards/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set Scan Metadata
         * @param {string} scanId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setScanMetadata: (scanId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scanId' is not null or undefined
            (0, common_1.assertParamExists)('setScanMetadata', 'scanId', scanId);
            const localVarPath = `/scans/{scan_id}/metadata`
                .replace(`{${"scan_id"}}`, encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Validate Magic Link
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMagicLink: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('validateMagicLink', 'token', token);
            const localVarPath = `/validate-magic-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CardScanApiAxiosParamCreator = CardScanApiAxiosParamCreator;
/**
 * CardScanApi - functional programming interface
 * @export
 */
const CardScanApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CardScanApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Card - Send performance data
         * @param {string} cardId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardPerformance(cardId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cardPerformance(cardId, body, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.cardPerformance']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Creates a new card
         * @param {CreateCardRequest} [createCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard(createCardRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCard(createCardRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.createCard']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create Eligibility Record
         * @param {CreateEligibilityRequest} [createEligibilityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEligibility(createEligibilityRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEligibility(createEligibilityRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.createEligibility']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete Card
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardById(cardId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCardById(cardId, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.deleteCardById']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Direct Upload
         * @param {ScanOrientation} orientation
         * @param {ScanCaptureType} captureType
         * @param {string} cardId
         * @param {string | any} [stringAny]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directUpload(orientation, captureType, cardId, stringAny, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.directUpload(orientation, captureType, cardId, stringAny, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.directUpload']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Card - Generate Upload URL
         * @param {string} cardId
         * @param {number} [expiration]
         * @param {GenerateCardUploadUrlRequest} [generateCardUploadUrlRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.generateCardUploadUrl']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Generate Magic Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMagicLink(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateMagicLink(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.generateMagicLink']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Generate an upload URL
         * @param {number} expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUploadUrl(expiration, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateUploadUrl(expiration, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.generateUploadUrl']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Access Token
         * @param {string} [userId] The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessToken(userId, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.getAccessToken']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get Card by ID
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardById(cardId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCardById(cardId, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.getCardById']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get Eligibility
         * @param {string} eligibilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityById(eligibilityId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEligibilityById(eligibilityId, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.getEligibilityById']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary List Cards
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCards(limit, cursor, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCards(limit, cursor, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.listCards']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary List Eligibility
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEligibility(limit, cursor, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEligibility(limit, cursor, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.listEligibility']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Search Cards (200) OK
         * @param {string} query
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCards(query, limit, cursor, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCards(query, limit, cursor, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.searchCards']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set Scan Metadata
         * @param {string} scanId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setScanMetadata(scanId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setScanMetadata(scanId, body, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.setScanMetadata']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         *
         * @summary Validate Magic Link
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMagicLink(token, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateMagicLink(token, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = base_1.operationServerMap['CardScanApi.validateMagicLink']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
exports.CardScanApiFp = CardScanApiFp;
/**
 * CardScanApi - factory interface
 * @export
 */
const CardScanApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CardScanApiFp)(configuration);
    return {
        /**
         *
         * @summary Card - Send performance data
         * @param {string} cardId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardPerformance(cardId, body, options) {
            return localVarFp.cardPerformance(cardId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new card
         * @param {CreateCardRequest} [createCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard(createCardRequest, options) {
            return localVarFp.createCard(createCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Eligibility Record
         * @param {CreateEligibilityRequest} [createEligibilityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEligibility(createEligibilityRequest, options) {
            return localVarFp.createEligibility(createEligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Card
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardById(cardId, options) {
            return localVarFp.deleteCardById(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Direct Upload
         * @param {ScanOrientation} orientation
         * @param {ScanCaptureType} captureType
         * @param {string} cardId
         * @param {string | any} [stringAny]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directUpload(orientation, captureType, cardId, stringAny, options) {
            return localVarFp.directUpload(orientation, captureType, cardId, stringAny, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Card - Generate Upload URL
         * @param {string} cardId
         * @param {number} [expiration]
         * @param {GenerateCardUploadUrlRequest} [generateCardUploadUrlRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options) {
            return localVarFp.generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate Magic Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMagicLink(options) {
            return localVarFp.generateMagicLink(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate an upload URL
         * @param {number} expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUploadUrl(expiration, options) {
            return localVarFp.generateUploadUrl(expiration, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Access Token
         * @param {string} [userId] The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken(userId, options) {
            return localVarFp.getAccessToken(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Card by ID
         * @param {string} cardId The ID of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardById(cardId, options) {
            return localVarFp.getCardById(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Eligibility
         * @param {string} eligibilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityById(eligibilityId, options) {
            return localVarFp.getEligibilityById(eligibilityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Cards
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCards(limit, cursor, options) {
            return localVarFp.listCards(limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Eligibility
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEligibility(limit, cursor, options) {
            return localVarFp.listEligibility(limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Cards (200) OK
         * @param {string} query
         * @param {number} [limit]
         * @param {string} [cursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCards(query, limit, cursor, options) {
            return localVarFp.searchCards(query, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set Scan Metadata
         * @param {string} scanId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setScanMetadata(scanId, body, options) {
            return localVarFp.setScanMetadata(scanId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate Magic Link
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMagicLink(token, options) {
            return localVarFp.validateMagicLink(token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CardScanApiFactory = CardScanApiFactory;
/**
 * CardScanApi - object-oriented interface
 * @export
 * @class CardScanApi
 * @extends {BaseAPI}
 */
class CardScanApi extends base_1.BaseAPI {
    constructor(configuration, basePath = base_1.BASE_PATH, axios = axios_1.default) {
        var _a, _b;
        super(new configuration_1.Configuration(configuration), basePath, axios);
        this.basePath = basePath;
        this.axios = axios;
        /**
         * Utility method to create a websocket connection
         * @param cb This callback will be invoked with the websocket object once the connection is established or with an error if the connection fails.
         */
        this.withWebsocket = (cb) => {
            var _a;
            const token = (_a = this.configuration.accessToken) !== null && _a !== void 0 ? _a : this.configuration.apiKey;
            const websocket = new isomorphic_ws_1.default(`${this.configuration.websocketUrl}?token=${token}`);
            this.debug("Connecting to websocket...");
            websocket.onerror = (err) => __awaiter(this, void 0, void 0, function* () {
                this.error(`Websocket error: ${err.message}`);
                yield cb(null, err);
            });
            websocket.onopen = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    this.debug("Websocket connected. Invoking callback...");
                    yield cb(websocket, null);
                }
                catch (e) {
                }
                finally {
                    this.debug("Websocket closing...");
                    websocket.close();
                }
            });
        };
        /**
          * Utility function to transform an object's fields to snake_case
         */
        this.toSnakeCase = (obj) => {
            if (Array.isArray(obj)) {
                return obj.map((item) => this.toSnakeCase(item));
            }
            else if (obj !== null && typeof obj === "object") {
                return Object.keys(obj).reduce((acc, key) => {
                    const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
                    const value = obj[key];
                    return Object.assign(Object.assign({}, acc), { [snakeKey]: this.toSnakeCase(value) });
                }, {});
            }
            return obj;
        };
        /**
         * Utility function to transform an object's fields to camelCase
         **/
        this.toCamelCase = (obj) => {
            if (Array.isArray(obj)) {
                return obj.map((item) => this.toCamelCase(item));
            }
            else if (obj !== null && typeof obj === "object") {
                return Object.keys(obj).reduce((acc, key) => {
                    const camelKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
                    const value = obj[key];
                    return Object.assign(Object.assign({}, acc), { [camelKey]: this.toCamelCase(value) });
                }, {});
            }
            return obj;
        };
        if (this.configuration.preInitializeWebsocket) {
            const token = (_a = this.configuration.accessToken) !== null && _a !== void 0 ? _a : this.configuration.apiKey;
            this.websocket = new isomorphic_ws_1.default(`${this.configuration.websocketUrl}?token=${token}`);
            this.debug("Connecting to websocket (Pre initializating)...");
        }
        this.configuration.nameCase = (_b = configuration.nameCase) !== null && _b !== void 0 ? _b : "camel";
    }
    /**
     * @summary Performs a full scan, including both front and back side scans. (This method requires a websocket URL to be set in the configuration.)
     * @param frontImage The front side image to scan. For client side code this can be a File object, for server side code this can be a Blob or a Stream.
     * @param backImage The back side image to scan. For client side code this can be a File object, for server side code this can be a Blob or a Stream.
     * */
    fullScan({ frontImage, backImage, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.info("Starting full scan...");
            if (!((_a = this.configuration) === null || _a === void 0 ? void 0 : _a.websocketUrl)) {
                this.error("Websocket URL not set in configuration.");
                throw new Error("This method cannot be called without a websocket URL.");
            }
            this.debug("Creating card...");
            const card = (yield this.createCard({
                enable_livescan: false,
                enable_backside_scan: Boolean(backImage),
            }, {
                forceOriginalCase: true,
            }));
            this.debug(`Card created successfully: ${JSON.stringify(card)}`);
            return new Promise((resolve, reject) => {
                this.withWebsocket((websocket, err) => __awaiter(this, void 0, void 0, function* () {
                    if (err) {
                        return reject(err);
                    }
                    this.debug("Registering websocket card...");
                    websocket.send(JSON.stringify({
                        action: "register",
                        card_id: card.card_id,
                    }));
                    this.debug("Websocket card registered");
                    this.debug("Generating front side upload URL...");
                    const frontSideUploadUrlResponse = (yield this.generateCardUploadUrl(card.card_id, 3600, {
                        orientation: models_2.ScanOrientation.Front,
                    }, { forceOriginalCase: true }));
                    this.debug(`Front side upload URL generated successfully, response: ${JSON.stringify(frontSideUploadUrlResponse)}}`);
                    const formDataFront = this.cardFormDataFactory(frontImage, frontSideUploadUrlResponse.upload_parameters);
                    try {
                        this.debug("Uploading front side image...");
                        yield this.axios.post(frontSideUploadUrlResponse.upload_url, formDataFront, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        this.debug("Front side image uploaded successfully");
                    }
                    catch (error) {
                        this.error(`Error uploading front side image. Error: ${error.message}`);
                        if (error.response && error.response.data) {
                            this.debug("Parsing error response...");
                            const parser = new fast_xml_parser_1.XMLParser();
                            const errorResponse = parser.parse(error.response.data);
                            const cardError = this.XMLErrorToCardScanError(errorResponse.Error, error.response.status);
                            this.debug(`Error response parsed successfully. Parsed error: ${error.response.data}`);
                            return reject(cardError);
                        }
                        else {
                            return reject(error);
                        }
                    }
                    const frontSideRejectionStates = [
                        models_1.CardState.FrontsideFailed,
                        models_1.CardState.Error,
                    ];
                    this.debug("Waiting for front side processing to complete...");
                    const frontSideEvent = yield new Promise((resolve, reject) => {
                        websocket.onmessage = (event) => {
                            var _a;
                            const data = JSON.parse(event.data);
                            this.debug(`Received websocket message: ${event.data}`);
                            if (data.type !== models_1.CardWebsocketEventTypeEnum.Card)
                                return;
                            if (frontSideRejectionStates.includes(data.state)) {
                                this.debug(`Received reject state while processing frontside: ${data.state}`);
                                return reject(new Error(`Frontside failed: ${(_a = data.error) === null || _a === void 0 ? void 0 : _a.message}`));
                            }
                            if (data.state === models_1.CardState.BacksideProcessing ||
                                data.state === models_1.CardState.Completed) {
                                this.debug("Front side processing completed successfully");
                                return resolve(data);
                            }
                        };
                    });
                    if (!backImage) {
                        this.info("Full scan completed successfully");
                        this.debug("Fetching card details...");
                        const cardDetails = (yield this.getCardById(frontSideEvent.card_id, { forceOriginalCase: true }));
                        if (this.configuration.nameCase === 'camel') {
                            return resolve(this.toCamelCase(cardDetails));
                        }
                        return resolve(this.toSnakeCase(cardDetails));
                    }
                    this.debug("Generating back side upload URL...");
                    const backSideUploadUrlResponse = (yield this.generateCardUploadUrl(card.card_id, 3600, {
                        orientation: models_2.ScanOrientation.Back,
                    }, {
                        forceOriginalCase: true,
                    }));
                    const formDataBack = this.cardFormDataFactory(backImage, backSideUploadUrlResponse.upload_parameters);
                    try {
                        this.debug("Uploading back side image...");
                        yield this.axios.post(backSideUploadUrlResponse.upload_url, formDataBack, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                    }
                    catch (error) {
                        this.error(`Error uploading back side image. Error: ${error.message}`);
                        if (error.response && error.response.data) {
                            this.debug("Parsing error response...");
                            const parser = new fast_xml_parser_1.XMLParser();
                            const errorResponse = parser.parse(error.response.data);
                            const cardError = this.XMLErrorToCardScanError(errorResponse.Error, error.response.status);
                            this.debug(`Error response parsed successfully. Parsed error: ${error.response.data}`);
                            return reject(cardError);
                        }
                        else {
                            return reject(error);
                        }
                    }
                    const backSideRejectionStates = [
                        models_1.CardState.BacksideFailed,
                        models_1.CardState.Error,
                    ];
                    this.debug("Waiting for back side processing to complete...");
                    const event = yield new Promise((resolve, reject) => {
                        websocket.onmessage = (event) => {
                            var _a;
                            const data = JSON.parse(event.data);
                            this.debug(`Received websocket message: ${event.data}`);
                            if (data.type !== models_1.CardWebsocketEventTypeEnum.Card)
                                return;
                            if (backSideRejectionStates.includes(data.state)) {
                                this.debug(`Received reject state while processing backside: ${data.state}`);
                                return reject(new Error(`Backside failed: ${(_a = data.error) === null || _a === void 0 ? void 0 : _a.message}`));
                            }
                            if (data.state === models_1.CardState.Completed) {
                                this.debug(`Back side processing completed successfully`);
                                return resolve(data);
                            }
                        };
                    });
                    this.info("Full scan completed successfully");
                    this.debug("Fetching card details...");
                    const cardDetails = (yield this.getCardById(event.card_id, {
                        forceOriginalCase: true,
                    }));
                    if (this.configuration.nameCase == 'camel') {
                        return resolve(this.toCamelCase(cardDetails));
                    }
                    resolve(this.toSnakeCase(cardDetails));
                }));
            });
        });
    }
    cardFormDataFactory(file, uploadParameters) {
        const formData = new form_data_1.default();
        for (const [key, value] of Object.entries(uploadParameters)) {
            formData.append(key, value);
        }
        formData.append("file", file);
        return formData;
    }
    XMLErrorToCardScanError(xmlErrorObj, code) {
        return {
            message: xmlErrorObj.Message,
            type: xmlErrorObj.Code,
            code,
        };
    }
    /**
     * @summary Performs an eligibility check for a card. (This method requires a websocket URL to be set in the configuration.)
     * @param cardId The ID of the card
     * @param eligibility The eligibility information to check
     * */
    checkEligibility(cardId, eligibility) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.configuration) === null || _a === void 0 ? void 0 : _a.websocketUrl)) {
                this.error("Websocket URL not set in configuration");
                throw new Error("This method cannot be called without a websocket URL.");
            }
            if (!this.validateEligibility(cardId, eligibility)) {
                throw new Error("Invalid eligibility information");
            }
            this.info(`Checking eligibility for card: ${cardId}`);
            return new Promise((resolve, reject) => {
                this.withWebsocket((websocket, err) => __awaiter(this, void 0, void 0, function* () {
                    if (err) {
                        this.error(`Error connecting to websocket: ${err.message}`);
                        return reject(err);
                    }
                    try {
                        this.debug(`Creating eligibility for card: ${cardId}`);
                        const response = (yield this.createEligibility({
                            card_id: cardId,
                            eligibility,
                        }, {
                            forceOriginalCase: true,
                        }));
                        this.debug(`Eligibility created successfully: ${JSON.stringify(response)}`);
                    }
                    catch (e) {
                        return reject(e);
                    }
                    this.debug("Registering card with websocket...");
                    websocket.send(JSON.stringify({
                        action: "register",
                        card_id: cardId,
                    }));
                    this.debug("Card registered with websocket");
                    this.debug("Waiting for eligibility check to complete...");
                    const event = yield new Promise((resolve, reject) => {
                        websocket.onmessage = (event) => {
                            var _a;
                            const data = JSON.parse(event.data);
                            this.debug(`Received websocket message: ${event.data}`);
                            if (data.state === models_1.EligibilityState.Completed) {
                                this.debug("Received completed state");
                                return resolve(data);
                            }
                            if (data.state === models_1.EligibilityState.Error) {
                                this.debug("Received error state");
                                return reject(new Error(`Eligibility process failed: ${(_a = data.error) === null || _a === void 0 ? void 0 : _a.message}`));
                            }
                        };
                    });
                    this.info(`Eligibility check completed successfully`);
                    const elig = (yield this.getEligibilityById(event.eligibility_id, {
                        forceOriginalCase: true,
                    }));
                    if (this.configuration.nameCase === 'camel') {
                        return resolve(this.toCamelCase(elig));
                    }
                    // Not necessary but calling toSnakeCase function makes the compiler happy :)
                    resolve(this.toSnakeCase(elig));
                }));
            });
        });
    }
    /**
     * Utility method to validate eligibility information
     * @returns The validated eligibility object
     * @throws {yup.ValidationError}
     */
    validateEligibility(cardId, eligibility) {
        this.debug(`Validating eligibility information. Raw input: ${JSON.stringify(eligibility)}`);
        const npiValid = this.npiValid.bind(this);
        const schema = yup.object({
            cardId: yup.string().required().uuid(),
            eligibility: yup.object({
                provider: yup
                    .object({
                    firstName: yup.string().when("organizationName", {
                        is: (organizationName) => !organizationName,
                        then: (schema) => schema.required("provider first name is required if organization name is not provided"),
                        otherwise: (schema) => schema.optional(),
                    }),
                    lastName: yup
                        .string()
                        .optional()
                        .when("organizationName", {
                        is: (organizationName) => !organizationName,
                        then: (schema) => schema.required("provider last name is required if organization name is not provided"),
                        otherwise: (schema) => schema.optional(),
                    }),
                    organizationName: yup.string().optional(),
                    npi: yup
                        .string()
                        .required("provider npi is a required field")
                        .test("isValidNpi", ({ originalValue }) => `npi "${originalValue}" is not valid`, function (value) {
                        return npiValid(value);
                    }),
                })
                    .required(),
                subscriber: yup
                    .object({
                    firstName: yup
                        .string()
                        .required("subscriber first name is a required field"),
                    lastName: yup
                        .string()
                        .required("subscriber last name is a required field"),
                    dateOfBirth: yup
                        .string()
                        .required("subscriber date of birth is a required field")
                        .test("isValidDate", ({ originalValue }) => `subscriber date of birth is not valid: "${originalValue}". Expected format: YYYYMMDD`, (value) => {
                        if (!value)
                            return true;
                        try {
                            let date;
                            let month;
                            let day;
                            let year;
                            // Check if it's already in YYYYMMDD format
                            if (/^\d{8}$/.test(value)) {
                                this.debug(`YYYYMMDD format matched: ${value}`);
                                year = parseInt(value.substring(0, 4), 10);
                                month = parseInt(value.substring(4, 6), 10);
                                day = parseInt(value.substring(6, 8), 10);
                            }
                            // Handle YYYY-MM-DD format
                            else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                                this.debug(`YYYY-MM-DD format matched: ${value}`);
                                [year, month, day] = value.split('-').map(num => parseInt(num, 10));
                            }
                            // Handle MM/DD/YYYY format
                            else if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
                                this.debug(`MM/DD/YYYY format matched: ${value}`);
                                [month, day, year] = value.split('/').map(num => parseInt(num, 10));
                            }
                            // Handle DD-MM-YYYY format
                            else if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
                                this.debug(`DD-MM-YYYY format matched: ${value}`);
                                [day, month, year] = value.split('-').map(num => parseInt(num, 10));
                            }
                            else {
                                this.debug(`No date format matched. Parsing with new Date(): ${value}`);
                                date = new Date(value);
                                if (isNaN(date.getTime())) {
                                    this.debug(`Date is not valid: ${value}`);
                                    return false;
                                }
                                year = date.getFullYear();
                                month = date.getMonth() + 1;
                                day = date.getDate();
                            }
                            if (month < 1 || month > 12)
                                return false;
                            if (day < 1 || day > 31)
                                return false;
                            if (year < 1900 || year > new Date().getFullYear() + 100)
                                return false;
                            const daysInMonth = new Date(year, month, 0).getDate();
                            if (day > daysInMonth)
                                return false;
                            date = new Date(year, month - 1, day);
                            if (isNaN(date.getTime()))
                                return false;
                            // Convert to YYYYMMDD format
                            const formattedDate = `${year}${String(month).padStart(2, '0')}${String(day).padStart(2, '0')}`;
                            // If the input was already in YYYYMMDD format, ensure it matches
                            if (/^\d{8}$/.test(value)) {
                                return formattedDate === value;
                            }
                            return true;
                        }
                        catch (e) {
                            this.debug(`Error validating date: ${e}`);
                            return false;
                        }
                    }),
                })
                    .required(),
            }),
        });
        return schema.validateSync({ cardId, eligibility }, { abortEarly: false });
    }
    toInt(num) {
        return Number.parseInt(num, 10);
    }
    sumDigits(int) {
        let sum = 0;
        while (int) {
            sum += int % 10;
            int = Math.floor(int / 10);
        }
        return sum;
    }
    ;
    doubleAlternate(value, index) {
        let pos = index !== null && index !== void 0 ? index : value.length - 1;
        let sum = 0;
        let alt = true;
        for (; pos >= 0; pos--) {
            const cur = this.toInt(value.charAt(pos));
            sum += alt ? this.sumDigits(cur * 2) : cur;
            alt = !alt;
        }
        return sum;
    }
    ;
    npiValid(id, prefix = '80840') {
        var _a, _b;
        const prefixRegex = /^80\d{3}$/;
        const npiRegex = /^\d{10}$/;
        const usPrefixSum = 24; // Precalculated value for 80840 (United States)
        const npi = (_a = id === null || id === void 0 ? void 0 : id.toString()) !== null && _a !== void 0 ? _a : '';
        const pre = (_b = prefix === null || prefix === void 0 ? void 0 : prefix.toString()) !== null && _b !== void 0 ? _b : '';
        if (!npiRegex.test(npi) || !prefixRegex.test(pre)) {
            return false;
        }
        const check = this.toInt(npi.charAt(9));
        const npiSum = this.doubleAlternate(npi, 8);
        const preSum = pre === '80840' ? usPrefixSum : this.doubleAlternate(pre, 3);
        const total = npiSum + preSum;
        const totalCeil = Math.ceil(total / 10) * 10;
        return totalCeil - total === check;
    }
    /**
     *
     * @summary Card - Send performance data
     * @param {string} cardId
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    cardPerformance(cardId, body, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).cardPerformance(cardId, body, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Creates a new card
     * @param {CreateCardRequest} [createCardRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    createCard(createCardRequest, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).createCard(createCardRequest, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Create Eligibility Record
     * @param {CreateEligibilityRequest} [createEligibilityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    createEligibility(createEligibilityRequest, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).createEligibility(createEligibilityRequest, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Delete Card
     * @param {string} cardId The ID of the card
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    deleteCardById(cardId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).deleteCardById(cardId, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Direct Upload
     * @param {ScanOrientation} orientation
     * @param {ScanCaptureType} captureType
     * @param {string} cardId
     * @param {string | any} [stringAny]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    directUpload(orientation, captureType, cardId, stringAny, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).directUpload(orientation, captureType, cardId, stringAny, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Card - Generate Upload URL
     * @param {string} cardId
     * @param {number} [expiration]
     * @param {GenerateCardUploadUrlRequest} [generateCardUploadUrlRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).generateCardUploadUrl(cardId, expiration, generateCardUploadUrlRequest, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Generate Magic Link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    generateMagicLink(options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).generateMagicLink(options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Generate an upload URL
     * @param {number} expiration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    generateUploadUrl(expiration, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).generateUploadUrl(expiration, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Access Token
     * @param {string} [userId] The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    getAccessToken(userId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).getAccessToken(userId, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Get Card by ID
     * @param {string} cardId The ID of the card
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    getCardById(cardId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).getCardById(cardId, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Get Eligibility
     * @param {string} eligibilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    getEligibilityById(eligibilityId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).getEligibilityById(eligibilityId, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary List Cards
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    listCards(limit, cursor, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).listCards(limit, cursor, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary List Eligibility
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    listEligibility(limit, cursor, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).listEligibility(limit, cursor, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Search Cards (200) OK
     * @param {string} query
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    searchCards(query, limit, cursor, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).searchCards(query, limit, cursor, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Set Scan Metadata
     * @param {string} scanId
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    setScanMetadata(scanId, body, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).setScanMetadata(scanId, body, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
    /**
     *
     * @summary Validate Magic Link
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardScanApi
     */
    validateMagicLink(token, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield (0, exports.CardScanApiFp)(this.configuration).validateMagicLink(token, options).then((request) => request(this.axios, this.basePath)).then(r => r.data);
            if (this.configuration.nameCase === 'camel' && !(options === null || options === void 0 ? void 0 : options.forceOriginalCase)) {
                data = this.toCamelCase(data);
            }
            return data;
        });
    }
}
exports.CardScanApi = CardScanApi;
